import { InventoryItemWithPricing } from '@galaxy/inventory-ui';
import { AppType } from '@vendasta/marketplace-apps';
import { LineItem, LineItemAppKey } from '@vendasta/sales-orders';
import { UILineItemWithEditionPricing } from '../../shared/interface';

export function inventoryItemsToLineItems(items: InventoryItemWithPricing[]): UILineItemWithEditionPricing[] {
  return items.map((item) => {
    const lineItem = new LineItem(item.pricing);
    let editionName: string = undefined;
    let appType: AppType = undefined;
    if (item.type === 'app') {
      editionName = item.edition?.name;
    }
    if (item.type !== 'package') {
      if (item.type === 'app') {
        lineItem.appKey = new LineItemAppKey({
          appId: item.itemId,
          editionId: item.edition?.editionId,
        });
        appType = AppType.APP_TYPE_APP;
      } else {
        lineItem.appKey = new LineItemAppKey({
          appId: item.itemId,
        });
        appType = AppType.APP_TYPE_ADDON;
      }
    } else {
      lineItem.packageId = item.itemId;
    }
    return {
      lineItem: lineItem,
      name: item.name,
      editionName: editionName,
      iconUrl: item.iconUrl,
      appType: appType,
    };
  });
}
